/* PILSNERISH OS — MAIL.EXE modal (snippets/pz-mail-modal.liquid, rendered once in layout/theme.liquid)
 * Opens from any [data-pz-mail-open] (delegated on document). Closes on Esc, the scrim or the title-bar ×.
 * Focus is trapped inside and returned to the opener. Scroll is locked (Lenis stopped via PZ.lock) while open.
 * The dialog behaviour itself (dodging [CANCEL], validation, states) is PZ.mailDialog from assets/pz-newsletter.js.
 */
(function () {
  'use strict';
  var w = window, d = document;
  var PZ = w.PZ || (w.PZ = {});
  if (PZ.mailModal) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var modal = null, dialog = null, lastFocus = null, isOpen = false, inited = false, closeT = 0, padded = false;

  function els() {
    if (!modal || !d.documentElement.contains(modal)) {
      modal = d.querySelector('[data-pz-mail-modal]');
      dialog = modal ? modal.querySelector('.pz-mm__dialog') : null;
      inited = false;
    }
    return !!(modal && dialog);
  }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && !el.closest('[hidden]'); }
  function focusables() { return [].slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(visible); }

  function lock(on) {
    var root = d.documentElement;
    if (on) {
      var sb = w.innerWidth - root.clientWidth;
      if (sb > 0) { d.body.style.paddingRight = sb + 'px'; padded = true; }
      root.classList.add('pz-mm-lock');
    } else {
      root.classList.remove('pz-mm-lock');
      if (padded) { d.body.style.paddingRight = ''; padded = false; }
    }
    if (PZ.lock) PZ.lock(on);
    else if (PZ.lenis) { if (on) PZ.lenis.stop(); else PZ.lenis.start(); }
  }

  function open(opener) {
    if (!els()) return false;
    if (!inited && PZ.mailDialog) { PZ.mailDialog(dialog); inited = true; }
    clearTimeout(closeT);
    if (!isOpen) lastFocus = opener && opener.focus ? opener : d.activeElement;
    isOpen = true;
    modal.hidden = false;
    modal.classList.remove('is-closing');
    void modal.offsetWidth;
    modal.classList.add('is-open');
    lock(true);
    d.addEventListener('keydown', onKey, true);
    var target = dialog.querySelector('[data-nl-main]:not([hidden]) .pz-nl__input') || dialog.querySelector('[data-nl-ok]:not([hidden]) [data-nl-okhead]') || focusables()[0];
    setTimeout(function () { if (isOpen && target) try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }, PZ.reduced ? 0 : 60);
    d.dispatchEvent(new CustomEvent('pz:mail-open'));
    return true;
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    d.removeEventListener('keydown', onKey, true);
    modal.classList.remove('is-open');
    modal.classList.add('is-closing');
    closeT = setTimeout(function () { modal.hidden = true; modal.classList.remove('is-closing'); }, PZ.reduced ? 0 : 200);
    lock(false);
    if (lastFocus && d.documentElement.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    lastFocus = null;
    d.dispatchEvent(new CustomEvent('pz:mail-close'));
  }
  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1], a = d.activeElement;
    if (!dialog.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  /* focus that escapes the dialog (e.g. a click on the page chrome under the scrim) comes back */
  d.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!isOpen || !dialog || dialog.contains(t)) return;
    /* leave the store's captcha challenge (an iframe appended to body) alone */
    if (t.tagName === 'IFRAME' || (t.querySelector && t.querySelector('iframe'))) return;
    var f = focusables()[0]; if (f) f.focus({ preventScroll: true });
  });

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var op = t.closest('[data-pz-mail-open]');
    if (op && !(dialog && dialog.contains(op))) {
      if (!els()) return; /* no modal on this page: let the fallback href (/#pz-newsletter) work */
      e.preventDefault();
      open(op);
      return;
    }
    if (isOpen && t.closest('[data-pz-mail-close]')) { e.preventDefault(); close(); }
  });

  /* back from a real post (/contact#pz-mail-modal-form redirects here) or a #pz-mail-modal link: show the dialog */
  function fromHash() {
    var h = w.location.hash;
    if (h === '#pz-mail-modal' || h === '#pz-mail-modal-form') open(null);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { setTimeout(fromHash, 0); });
  else setTimeout(fromHash, 0);
  w.addEventListener('hashchange', fromHash);

  PZ.mailModal = { open: open, close: close, isOpen: function () { return isOpen; } };
})();
